var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1444.21 184.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke-width:10px;}.cls-1,.cls-2{stroke:#fff;stroke-miterlimit:10;}.cls-2{fill:#fff;stroke-width:7.21px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "imagehub scheme") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 721.1,
    x2: 721.1,
    y2: 164
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 18.1,
    y1: 165,
    x2: 1424.1,
    y2: 165
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 19.1,
    cy: 165,
    r: 15.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 532.1,
    cy: 165,
    r: 15.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1068.1,
    cy: 165,
    r: 15.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1425.1,
    cy: 165,
    r: 15.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLines);
export default __webpack_public_path__ + "static/media/lines.2b1549b3c23807cea871dd6081665fe6.svg";
export { ForwardRef as ReactComponent };